import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { BonificacionesextrasRoutingModule } from './bonificacionesextras-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { BonificacionesextrasComponent } from './components/bonificacionesextras/bonificacionesextras.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { OpcionesCargaDialogComponent } from './components/opciones-carga-dialog/opciones-carga-dialog.component';
import { DetalleBonificacionDialogComponent } from './components/detalle-bonificacion-dialog/detalle-bonificacion-dialog.component';
import { BonificacionesService } from './services/bonificaciones.service';

@NgModule({
  declarations: [
    BonificacionesextrasComponent,
    ConfirmDialogComponent,
    OpcionesCargaDialogComponent,
    DetalleBonificacionDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    BonificacionesextrasRoutingModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    ReactiveFormsModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatCardModule,
    MatExpansionModule,
    MatSortModule,
    MatRadioModule,
    MatSnackBarModule
  ],
  providers: [
    BonificacionesService
  ]
})
export class BonificacionesextrasModule { }
